import { CheckCircle2, XCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Button } from '@/components/ui/Button';
import { queryKeys } from '@/lib/api/queryKeys';
import { useT } from '@/lib/i18n/useT';

export function CheckoutSuccessPage() {
  const queryClient = useQueryClient();
  const t = useT();
  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: queryKeys.plans.current });
    queryClient.invalidateQueries({ queryKey: queryKeys.plans.invoices });
  }, [queryClient]);

  return (
    <div className="flex min-h-screen items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-full bg-[rgb(16_185_129/0.1)] text-[var(--color-success)]">
          <CheckCircle2 className="h-8 w-8" />
        </div>
        <h1 className="text-3xl font-bold">{t('checkoutResult.successTitle')}</h1>
        <p className="mt-2 text-sm text-[var(--color-fg-muted)]">
          {t('checkoutResult.successBody')}
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/settings/billing">
            <Button variant="secondary">{t('checkoutResult.seeBilling')}</Button>
          </Link>
          <Link to="/">
            <Button>{t('checkoutResult.backToDashboard')}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export function CheckoutCancelPage() {
  const t = useT();
  return (
    <div className="flex min-h-screen items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-full bg-[rgb(239_68_68/0.1)] text-[var(--color-error)]">
          <XCircle className="h-8 w-8" />
        </div>
        <h1 className="text-3xl font-bold">{t('checkoutResult.cancelTitle')}</h1>
        <p className="mt-2 text-sm text-[var(--color-fg-muted)]">
          {t('checkoutResult.cancelBody')}
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/pricing">
            <Button>{t('checkoutResult.seePlans')}</Button>
          </Link>
          <Link to="/">
            <Button variant="ghost">{t('checkoutResult.backToDashboard')}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
